var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cozeMain",staticClass:"cozeMain"},[_c('CozeChat',{attrs:{"agentId":"7557716315776663567","cozeWidth":_vm.cozeWidth,"title":"课后AI辅导助手"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }